import { TransformedProduct } from "../../product/types/productApiTypes";

/**
 * Sorts an array of products based on a specific order of IDs (e.g., LIFO from storage).
 *
 * @param products The array of fetched product objects.
 * @param itemIds The array of IDs defining the desired order.
 * @returns An array of products sorted according to itemIds.
 */
export const sortProductsByIds = (
  products: TransformedProduct[] | undefined,
  itemIds: number[] | undefined
): TransformedProduct[] => {
  if (!products || !itemIds) return [];

  const productMap = new Map(products.map((p) => [p.id, p]));

  return itemIds
    .map((id) => productMap.get(id))
    .filter((p): p is TransformedProduct => p !== undefined);
};
